import { Link, useLocation, useNavigate } from "react-router-dom";
import { Facebook, Instagram, Mail } from "lucide-react";
import { BUSINESS, CONTACT } from "@/data/content";
import { scrollToHash } from "@/lib/scroll";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const go = (hash) => {
    if (location.pathname !== "/") navigate("/", { state: { scrollTo: hash } });
    else scrollToHash(hash);
  };

  return (
    <footer data-testid="site-footer" className="border-t border-[#D4AF37]/20 bg-[#F1EADA]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div>
              <p className="font-display text-2xl tracking-[0.18em] text-[#1B3A6B]">TARAH</p>
              <p className="mt-1 font-label text-[10px] tracking-[0.4em] text-[#9A7B24]">CAKE DESIGN STUDIO</p>
            </div>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#67718A]">
              A new, home-based cake design studio in Drogheda making custom cakes,
              cupcakes, cookies, brownies and bento boxes — fresh to order.
            </p>
          </div>

          <div>
            <p className="font-label text-xs tracking-[0.3em] text-[#D4AF37]">EXPLORE</p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-[#2F4A78]">
              <button data-testid="footer-link-prices" onClick={() => go("#prices")} className="w-fit transition-colors hover:text-[#D4AF37]">Menu &amp; Prices</button>
              <button data-testid="footer-link-gallery" onClick={() => go("#gallery")} className="w-fit transition-colors hover:text-[#D4AF37]">Gallery</button>
              <button data-testid="footer-link-gifts" onClick={() => go("#gifts")} className="w-fit transition-colors hover:text-[#D4AF37]">Gifts with Cake</button>
              <button data-testid="footer-link-payment" onClick={() => go("#payment")} className="w-fit transition-colors hover:text-[#D4AF37]">How to Order</button>
              <Link data-testid="footer-link-story" to="/story" className="w-fit transition-colors hover:text-[#D4AF37]">Founder Story</Link>
              <button data-testid="footer-link-reviews" onClick={() => go("#reviews")} className="w-fit transition-colors hover:text-[#D4AF37]">Reviews</button>
            </div>
          </div>

          <div>
            <p className="font-label text-xs tracking-[0.3em] text-[#D4AF37]">CONTACT</p>
            <div className="mt-5 space-y-3 text-sm leading-relaxed text-[#2F4A78]">
              <p>{CONTACT.address}</p>
              <p>{CONTACT.email}</p>
              <p>{CONTACT.phone}</p>
              <p className="text-xs uppercase tracking-[0.2em] text-[#67718A]">{CONTACT.hours}</p>
            </div>
            <div className="mt-6 flex gap-3">
              <a data-testid="social-instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="rounded-full border border-[#D4AF37]/30 p-2.5 text-[#9A7B24] transition-colors hover:bg-[#D4AF37] hover:text-[#1B3A6B]">
                <Instagram size={17} />
              </a>
              <a data-testid="social-facebook" href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="rounded-full border border-[#D4AF37]/30 p-2.5 text-[#9A7B24] transition-colors hover:bg-[#D4AF37] hover:text-[#1B3A6B]">
                <Facebook size={17} />
              </a>
              <a data-testid="social-email" href={`mailto:${CONTACT.email}`} aria-label="Email" className="rounded-full border border-[#D4AF37]/30 p-2.5 text-[#9A7B24] transition-colors hover:bg-[#D4AF37] hover:text-[#1B3A6B]">
                <Mail size={17} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#D4AF37]/10 pt-8 sm:flex-row">
          <p className="text-xs tracking-wide text-[#67718A]">
            © {new Date().getFullYear()} Tarah — Cake Design Studio. All rights reserved.
          </p>
          <p className="font-display text-sm italic text-[#9A7B24]">Made with care in Drogheda.</p>
        </div>
        <p data-testid="footer-business-details" className="mt-4 text-center text-xs leading-relaxed tracking-wide text-[#67718A] sm:text-left">
          {BUSINESS.legal}
        </p>
      </div>
    </footer>
  );
};
